<script setup>
import Tabs from '@/components/neta/Tabs.vue';
import RankingTag from '@/components/neta/RankingTag.vue';
import RankingKey from '@/components/neta/RankingKey.vue';
import MediaBox  from '@/components/common/MediaBox.vue'
import Help  from '@/components/help/Help.vue'
import Side from "@/components/common/Sidebanner.vue";

import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-sheet>
<v-toolbar
	tile
	flat
	height="50px"
	color="#F2F2F2"
	class="mx-2 mt-2"
>
<v-row
>
	<v-col cols="3" class="pb-0 px-2">
	<v-select
		:items="thermitem"
        item-text="label"
        item-value="cd"
		v-model="therm"
		class="pa-0 w-100"
		label="カテゴリ"
	>
	</v-select>
	</v-col>
	<v-col cols="3" class="pb-0 px-2">
	<v-select
		:items="kinditem"
		v-model="kind"
		class="pa-0"
        item-text="label"
        item-value="cd"
		label="種類"
	>
	</v-select>
	</v-col>
	<v-col>
	</v-col>
</v-row>
<v-spacer />
<Help />
</v-toolbar>
<div class="cont">
<div class="mainarea">
	<v-card
		tile
		flat
	>
		<v-card-text class="pt-1">
			<span class="top_message"><img src="https://qlipper.jp/img/logo.svg" width="80.px" style="margin-right:10px;">のモニタリング結果を元にプレスリリースサイトから送信されたリリースの過去１ヶ月間のトレンドを算出しています。</span>
		</v-card-text>
		<Tabs :therm="selected_therm" :kind="selected_kind" :keyword="keyword" :tag="tag" />
	</v-card>
</div>
<div>
<div class="infoarea">
	<v-card
		tile
		flat
	>
		<v-tabs
			v-model="tab"
			fixed-tabs
			background-color="#E13532"
			dark
		>
			<v-tabs-slider color="yellow"></v-tabs-slider>
			<v-tab>
				話題
			</v-tab>
			<v-tab>
				タグ
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab">
			<v-tab-item>
				<RankingKey ref="rkey" v-on:keysearch="ksearch($event)" :therm="therm" :kind="kind" />
			</v-tab-item>
			<v-tab-item>
				<RankingTag ref="rtag" v-on:keysearch="tsearch($event)" :therm="therm" :kind="kind" />
			</v-tab-item>
		</v-tabs-items>
	</v-card>
	<MediaBox />
	<Side />
</div>
</div>
</div>
</v-sheet>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: 'ネタ探し',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/recom_doc_list.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/recom_dialog.css" },
          { rel: 'stylesheet', href: "./css/neta.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },
    computed: {
        _allquery() {
              return [this.therm, this.kind,];
        }   
    },          
    watch : {
        _allquery() {
			this.tag = "";
			this.keyword = "";
			this.selected_therm = this.therm;
			this.selected_kind  = this.kind;
        },
    },  
	data : function(){
		return {
			tab : null,
			thermitem : [],
			kinditem : [],
			therm : null,
			kind : null,
			selected_therm : null,
			selected_kind : null,
			tag  : "",
			keyword  : "",
		};
	},
	methods : {
		ksearch : function(data){
			if(this.tag != "")
				this.$refs.rtag.reset();
			this.keyword=data.keyword;
			this.tag="";
		},
		tsearch : function(data){
			if(this.keyowrd != "")
				this.$refs.rkey.reset();
			this.keyword="";
			this.tag=data.keyword;

		},
	},
	mounted : function(){
	},
	created : async function(){

        var params = new URLSearchParams();
        await axios.post("https://qlipper.jp/api/release/get_search_box",params)
        .then(response => {
            this.thermitem = response.data['category'];
            this.kinditem = response.data['kind'];
        }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });
	},
}
</script>
